import { MenuOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import { ColumnsType } from 'antd/es/table';
import cn from 'classnames';
import * as React from 'react';
import { TFunction } from 'react-i18next';

import { DOM_NODES_IDS } from 'config/domNodesIds';
import { CatalogFormFieldEntity } from 'entities/CatalogFormField';
import { FormFieldTableRow } from 'entities/Form';
import { EditFormStore } from 'stores/local';
import { FormFieldModel } from 'stores/local/forms/models';

import s from './EditFormTable.module.scss';
import {
  FillingMethodColumn,
  ImportEditableColumn,
  PivotScreenColumn,
  VisibilityColumn,
  ByDefaultColumn,
  RequiredFieldColumn,
  SettingsColumn,
  SetupIndicatorColumn,
  DataTypeColumn,
  NameColumn,
} from './components';

/** Структура данных для рендера контента внутри столбцов*/
export const getColumns = (
  store: EditFormStore,
  t: TFunction
): ColumnsType<FormFieldTableRow<FormFieldModel, CatalogFormFieldEntity>> => [
  {
    title: '',
    dataIndex: 'dragHandle',
    key: 'dragHandle',
    render: (_, record) => {
      return (
        <MenuOutlined
          id={`${DOM_NODES_IDS.EDIT_FORM_TABLE_ROW_DRAG_HANDLER(
            record.formField.id
          )}`}
          className={s.table__dragHandle}
        />
      );
    },
  },
  {
    title: '',
    dataIndex: 'setupIndicator',
    key: 'setupIndicator',
    onHeaderCell: () => ({
      className: s.table__headerCell_resetBorder,
    }),
    render: (_, record) => {
      return <SetupIndicatorColumn record={record} editFormStore={store} />;
    },
  },
  {
    title: (
      <Typography.Text className={s.table__columnTitle}>
        {t('editForm.columns.name')}
      </Typography.Text>
    ),
    dataIndex: 'name',
    key: 'name',
    onHeaderCell: () => ({
      className: s.table__headerCell_resetBorder,
    }),
    render: (_, record) => {
      return <NameColumn record={record} editFormStore={store} />;
    },
  },
  {
    title: (
      <Typography.Text className={s.table__columnTitle}>
        {t('editForm.columns.dataType')}
      </Typography.Text>
    ),
    dataIndex: 'dataType',
    key: 'dataType',
    onHeaderCell: () => ({
      className: s.table__headerCell_resetBorder,
    }),
    render: (_, record) => {
      return <DataTypeColumn record={record} editFormStore={store} />;
    },
  },
  {
    title: (
      <Typography.Text className={s.table__columnTitle}>
        {t('editForm.columns.fillingMethod')}
      </Typography.Text>
    ),
    dataIndex: 'fillingMethod',
    key: 'fillingMethod',
    onHeaderCell: () => ({
      className: s.table__headerCell_resetBorder,
    }),
    render: (_, record) => {
      return <FillingMethodColumn record={record} editFormStore={store} />;
    },
  },
  {
    title: (
      <Typography.Text className={s.table__columnTitle}>
        {t('editForm.columns.importEditable')}
      </Typography.Text>
    ),
    dataIndex: 'importEditable',
    key: 'importEditable',
    onHeaderCell: () => ({
      className: s.table__headerCell_resetBorder,
    }),
    render: (_, record) => {
      return <ImportEditableColumn record={record} editFormStore={store} />;
    },
  },
  {
    title: (
      <Typography.Text className={s.table__columnTitle}>
        {t('editForm.columns.visibility')}
      </Typography.Text>
    ),
    key: 'visibility',
    dataIndex: 'visibility',
    onHeaderCell: () => ({
      className: cn(s.table__visibilyCell, s.table__headerCell_resetBorder),
    }),
    onCell: () => ({
      className: s.table__visibilyCell,
    }),
    render: (_, record) => {
      return <VisibilityColumn record={record} editFormStore={store} />;
    },
  },
  {
    title: (
      <Typography.Text className={s.table__columnTitle}>
        {t('editForm.columns.pivotScreen')}
      </Typography.Text>
    ),
    key: 'pivotScreen',
    onHeaderCell: () => ({
      className: s.table__headerCell_resetBorder,
    }),
    dataIndex: 'pivotScreen',
    render: (_, record) => {
      return <PivotScreenColumn record={record} editFormStore={store} />;
    },
  },
  {
    title: (
      <Typography.Text className={s.table__columnTitle}>
        {t('editForm.columns.byDefault')}
      </Typography.Text>
    ),
    key: 'byDefault',
    onHeaderCell: () => ({
      className: s.table__headerCell_resetBorder,
    }),
    dataIndex: 'byDefault',
    render: (_, record) => {
      return <ByDefaultColumn record={record} editFormStore={store} />;
    },
  },
  {
    title: '',
    key: 'settings',
    onHeaderCell: () => ({
      className: s.table__headerCell_resetBorder,
    }),
    dataIndex: 'settings',
    render: (_, record) => {
      return <SettingsColumn record={record} editFormStore={store} />;
    },
  },
  {
    title: '',
    key: 'requiredField',
    onHeaderCell: () => ({
      className: s.table__headerCell_resetBorder,
    }),
    dataIndex: 'requiredField',
    render: (_, record) => {
      return <RequiredFieldColumn record={record} editFormStore={store} />;
    },
  },
];
